import { Jsonld } from "../../../jsonld";
import type { SchemaProjectName } from "../../schema-constants";
import { SCHEMA_CONTEXT } from "../../schema-constants";

interface OnlineBusinessSchemaProps {
  readonly projectName?: SchemaProjectName;
}

export function OnlineBusinessSchema({ projectName = "rb" }: OnlineBusinessSchemaProps) {
  const schemaTypeId = `jsonld_online_business_${projectName}`;
  const data = {
    "@context": SCHEMA_CONTEXT,
    "@type": "OnlineBusiness",
    "name": "Webmotors",
    "url": "https://www.webmotors.com.br",
    "logo": "https://www.webmotors.com.br/favicon.ico",
    "description": "A maior plataforma de compra e venda de veículos do Brasil.",
    "sameAs": [
      "https://www.facebook.com/webmotors",
      "https://www.instagram.com/webmotors",
      "https://www.youtube.com/user/webmotors",
      "https://x.com/webmotors"
    ]
  };
  return <Jsonld id={schemaTypeId} dataSchema={data} dataQa={schemaTypeId} />;
}